import { render, staticRenderFns } from "./CardIssueRecords.vue?vue&type=template&id=68b07254&scoped=true"
import script from "./CardIssueRecords.vue?vue&type=script&lang=js"
export * from "./CardIssueRecords.vue?vue&type=script&lang=js"
import style0 from "./CardIssueRecords.vue?vue&type=style&index=0&id=68b07254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b07254",
  null
  
)

export default component.exports